export function createRng(seed: number | string = 1): {
  next(): number;
  readonly state: number;
} {
  let state = normalizeSeed(seed);

  return {
    next() {
      state = (state * 1664525 + 1013904223) >>> 0;
      return state / 0x100000000;
    },
    get state() {
      return state;
    },
  };
}

export function normalizeSeed(seed: number | string): number {
  if (typeof seed === 'number') {
    return normalizeNumericSeed(seed);
  }

  // Numeric strings (e.g. "42") keep the existing numeric behavior.
  const numeric = Number(seed);
  if (seed.trim() !== '' && Number.isFinite(numeric)) {
    return normalizeNumericSeed(numeric);
  }

  // Non-numeric strings (e.g. "intro"): hash into a stable, distinct 32-bit
  // integer instead of silently collapsing every such seed to the same
  // fallback value (the previous behavior, which meant differently-named
  // levels like "intro" and "switchback" produced identical layouts).
  return (hashStringToUint32(seed) || 1) >>> 0;
}

function normalizeNumericSeed(numeric: number): number {
  if (!Number.isFinite(numeric)) {
    return 1;
  }
  return (Math.abs(Math.trunc(numeric)) || 1) >>> 0;
}

/** Deterministic FNV-1a 32-bit string hash, used to turn arbitrary seed strings into distinct RNG states. */
function hashStringToUint32(value: string): number {
  let hash = 0x811c9dc5; // FNV-1a 32-bit offset basis
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0; // FNV-1a 32-bit prime
  }
  return hash >>> 0;
}
